import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ModalComponent } from '../../../components/modal/modal.component';
import { CreateSubgroupComponent } from '../create-subgroup/create-subgroup.component';
import { SubgroupService } from '../subgroup.service';
import { Subgroup } from '../../../models/subgroup.model';

@Component({
  selector: 'app-list-subgroup',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    FormsModule,
    ModalComponent,
    CreateSubgroupComponent,
    PaginatorModule
  ],
  templateUrl: './list-subgroup.component.html'
})
export class ListSubgroupComponent implements OnInit {
  subgroupId!: number | null;
  searchTerm = '';
  totalRecords = 0;
  subgroups: Subgroup[] = [];
  loading = false;
  formVisible = false;
  first = 0;
  rows = 5;
  currentPage = 1;

  constructor(private location: Location, private subgroupService: SubgroupService) {}

  ngOnInit(): void {
    this.getData();
  }

  closeModal(): void {
    this.subgroupId = null;
  }

  getData(): void {
    this.subgroupService.getAll(this.searchTerm, undefined, true, this.currentPage).subscribe({
      next: data => {
        this.subgroups = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  groupLabel(s: Subgroup): string {
    return s.group?.description ?? `Grupo #${s.groupId}`;
  }

  onPageChange(event: { first?: number }): void {
    this.first = event.first ?? 0;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  createSubgroup(): void {
    this.changeModal();
  }

  onFormSubmit(): void {
    this.changeModal();
    this.getData();
  }

  changeModal(): void {
    this.formVisible = !this.formVisible;
  }

  edit(s: Subgroup): void {
    this.subgroupId = s.id;
    this.changeModal();
  }

  goBack(): void {
    this.location.back();
  }
}
